import Vue from 'vue';
import App from '@/App.vue';
import '@/style/index.less';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import toast from '@/components/toast/index';
import promt from '@/components/promt/index';
import loading from '@/components/loading/index';
import confirm from '@/components/confirm/index';
import login from '@/components/googleLogin/index';
import pay from '@/components/payment/index';
import { pixel } from '@/api';
import { getUrlParams, getItem, setItem } from '@/utils';

Vue.config.productionTip = false;
Vue.prototype.$toast = toast;
Vue.prototype.$promt = promt;
Vue.prototype.$loading = loading;
Vue.prototype.$confirm = confirm;
Vue.prototype.$login = login;
Vue.prototype.$pay = pay;

const pixelKey = 'comics_v1_pixel';
const params = getUrlParams();
if ((params.tt_pixel || params.pixel_id) && !getItem(pixelKey)) {
  pixel({ params });
  setItem(pixelKey, true);
}

function createApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}

createApp();
